let enableLogs = document.body.dataset.enabledebuglogs == '1';

export async function getAllUserMeta() {
	const response = await callUserApi('get_all_user_meta');
	enableLogs && console.log('🚀 ~ getAllUserMeta ~ response:', response);
	return response;
}

export async function getUserCourseData(userData = null) {
	const response = await callUserApi('get_user_course_data', userData);
	enableLogs && console.log('🚀 ~ getUserCourseData ~ response:', response);
	return response;
}

export async function initializeUserData(userData = {user_id: 0}) {
	const response = await callUserApi('initialize_user_data', userData);
	enableLogs && console.log('🚀 ~ initializeUserData ~ response:', response);
	return response;
}

export async function deleteUserData() {
	const response = await callUserApi('delete_user_data');
	enableLogs && console.log('🚀 ~ deleteUserData ~ response:', response);
	return response;
}

export async function setContinuePoint(
	userData = {post_type: 'level', post_id: 0}
) {
	enableLogs && console.log('Setting continue point...');
	const response = await callUserApi('set_continue_point', userData);
	enableLogs && console.log('Set continue point response: ', response);
	return response;
}

export async function setUserData(userData = {post_type: 'level', post_id: 0}) {
	const response = await callUserApi('set_user_data', userData);
	enableLogs &&
		console.log(
			'Set user data response: ',
			response + ' ' + userData.post_id
		);
	return response;
}

async function callUserApi(type = 'get_full_name', userData = null) {
	if (type !== null) {
		const userId = userData?.user_id || myUserData.id;
		const response = await fetch(
			`/wp-json/user/v2/${type}?` +
				new URLSearchParams({
					user_id: userId,
					user_data: JSON.stringify(userData || {})
				}).toString(),
			{
				headers: {
					'X-WP-Nonce': myUserData.nonce
				},
				credentials: 'same-origin'
			}
		);

		if (response.ok) {
			const data = await response.json();
			return data;
		} else {
			console.error('Failed to retrieve user data.');
			return null;
		}
	} else {
		return 'No type provided.';
	}
}
